import styled from "@emotion/styled";
import Modal from "react-modal";
import UI from "@mile-meeting/mile-ui";
import { getKorDate, getTimeString } from "utils/date";
import { useState } from "react";
import { FadeLoader } from "react-spinners";
import { TEmailNoShowRepeatReservation } from "../types";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type TRepeatCancelModal = {
  onHandleCancel: () => Promise<void>;
  openModal: boolean;
  closeModal: () => void;
};

const NotRepeatCancelModal = (props: TRepeatCancelModal) => {
  const { onHandleCancel, openModal, closeModal } = props;
  const [loading, setLoading] = useState<boolean>(false);

  const onHandleBtn = async () => {
    if (loading) return;
    setLoading(true);
    await onHandleCancel();
    setLoading(false);
  };

  return (
    <Modal style={modalStyle} isOpen={openModal} onRequestClose={closeModal}>
      <Container>
        <CancelContainer>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelContainer>
        <UpperSection>
          <AlertIcon>
            <UI.Icon name="info" size={56} color="var(--alias-color-status-negative)" />
          </AlertIcon>
          <Content>
            <UI.Typography
              type="heading01"
              fontStyle="bold"
              color="var(--alias-color-label-normal)"
              style={{
                textAlign: "center",
              }}
            >
              예약을 바로 취소하시겠습니까?
            </UI.Typography>
            <UI.Typography
              type="body01 normal"
              fontStyle="medium"
              color="var(--alias-color-label-alternative)"
              style={{
                textAlign: "center",
              }}
            >
              예약을 취소하면 복구할 수 없습니다.
            </UI.Typography>
          </Content>
        </UpperSection>
        <UI.Button
          title={"예약 취소하기"}
          size="large"
          type="outlined"
          style={{ width: "100%", gap: 0 }}
          onClick={onHandleBtn}
          suffixIcon={
            <div
              style={{
                transform: "scale(0.3)",
                display: "inline-flex",
                width: 16,
              }}
            >
              <FadeLoader color="white" height={16} radius={4} width={4} />
            </div>
          }
          showSuffixIcon={loading}
        />
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  width: 454px;
  padding: 48px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;

  border-radius: 20px;
  background: var(--alias-color-background-normal-normal);
  box-shadow: var(---alias-style-shadow-heavy);
`;

const CancelContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

const UpperSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const AlertIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 40px 0px rgba(255, 62, 62, 0.4);
  border-radius: 50%;
  width: 46px;
  height: 46px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--alias-color-line-normal);
`;
export default NotRepeatCancelModal;
